// Comprehensive database of dog breeds with detailed information for matching
// Based on American Kennel Club (AKC) classifications and breed standards

export const dogBreeds = [
  // SPORTING GROUP
  {
    id: 'labrador-retriever',
    name: 'Labrador Retriever',
    category: 'Sporting',
    size: 'Large',
    weight: '55-80 lbs',
    height: '21.5-24.5 inches',
    energyLevel: 'High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Low',
    shedding: 'High',
    lifespan: '10-12 years',
    climate: ['Cold', 'Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Friendly', 'Active', 'Outgoing', 'Loyal'],
    commonIssues: ['Hip dysplasia', 'Exercise induced collapse', 'Eye problems'],
    availability: 'Very High',
    searchTerms: ['labrador retriever', 'lab dog', 'labrador']
  },
  {
    id: 'golden-retriever',
    name: 'Golden Retriever',
    category: 'Sporting',
    size: 'Large',
    weight: '55-75 lbs',
    height: '21.5-24 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '10-12 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Friendly', 'Reliable', 'Trustworthy', 'Confident'],
    commonIssues: ['Hip dysplasia', 'Cancer', 'Heart disease'],
    availability: 'Very High',
    searchTerms: ['golden retriever', 'golden dog']
  },
  {
    id: 'german-shorthaired-pointer',
    name: 'German Shorthaired Pointer',
    category: 'Sporting',
    size: 'Large',
    weight: '45-70 lbs',
    height: '21-25 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Friendly', 'Smart', 'Willing to Please', 'Enthusiastic'],
    commonIssues: ['Hip dysplasia', 'Bloat'],
    availability: 'High',
    searchTerms: ['german shorthaired pointer', 'gsp']
  },
  {
    id: 'english-springer-spaniel',
    name: 'English Springer Spaniel',
    category: 'Sporting',
    size: 'Medium',
    weight: '40-50 lbs',
    height: '19-20 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Friendly', 'Playful', 'Obedient', 'Affectionate'],
    commonIssues: ['Hip dysplasia', 'Eye disorders', 'Ear infections'],
    availability: 'High',
    searchTerms: ['english springer spaniel', 'springer spaniel']
  },
  {
    id: 'cocker-spaniel',
    name: 'Cocker Spaniel',
    category: 'Sporting',
    size: 'Medium',
    weight: '20-30 lbs',
    height: '13.5-15.5 inches',
    energyLevel: 'Medium-High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-14 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Gentle', 'Smart', 'Happy', 'Merry'],
    commonIssues: ['Ear infections', 'Eye problems', 'Allergies'],
    availability: 'High',
    searchTerms: ['cocker spaniel', 'american cocker spaniel']
  },
  {
    id: 'vizsla',
    name: 'Vizsla',
    category: 'Sporting',
    size: 'Medium',
    weight: '45-60 lbs',
    height: '21-24 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '12-14 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Affectionate', 'Energetic', 'Loyal', 'Gentle'],
    commonIssues: ['Hip dysplasia', 'Epilepsy', 'Cancer'],
    availability: 'Medium',
    searchTerms: ['vizsla', 'hungarian vizsla']
  },
  {
    id: 'weimaraner',
    name: 'Weimaraner',
    category: 'Sporting',
    size: 'Large',
    weight: '55-90 lbs',
    height: '23-27 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-13 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Fearless', 'Friendly', 'Alert', 'Obedient'],
    commonIssues: ['Hip dysplasia', 'Bloat', 'Hyperactivity'],
    availability: 'Medium',
    searchTerms: ['weimaraner', 'silver ghost']
  },
  {
    id: 'brittany',
    name: 'Brittany',
    category: 'Sporting',
    size: 'Medium',
    weight: '30-40 lbs',
    height: '17.5-20.5 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Bright', 'Fun-Loving', 'Optimistic', 'Quick'],
    commonIssues: ['Hip dysplasia', 'Epilepsy'],
    availability: 'Medium',
    searchTerms: ['brittany', 'brittany spaniel']
  },
  {
    id: 'english-setter',
    name: 'English Setter',
    category: 'Sporting',
    size: 'Medium',
    weight: '45-80 lbs',
    height: '24-25 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Gentle', 'Friendly', 'Placid', 'Mellow'],
    commonIssues: ['Hip dysplasia', 'Elbow dysplasia', 'Deafness'],
    availability: 'Medium',
    searchTerms: ['english setter', 'setter dog']
  },
  {
    id: 'pointer',
    name: 'Pointer',
    category: 'Sporting',
    size: 'Large',
    weight: '45-75 lbs',
    height: '23-28 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '12-15 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Even-tempered', 'Alert', 'Hardworking', 'Independent'],
    commonIssues: ['Hip dysplasia', 'Eye disorders', 'Allergies'],
    availability: 'Medium',
    searchTerms: ['pointer', 'english pointer']
  },
  
  // HOUND GROUP
  {
    id: 'beagle',
    name: 'Beagle',
    category: 'Hound',
    size: 'Small',
    weight: '20-30 lbs',
    height: '13-15 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'High',
    shedding: 'Medium',
    lifespan: '10-15 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Merry', 'Friendly', 'Curious', 'Determined'],
    commonIssues: ['Obesity', 'Epilepsy', 'Hypothyroidism'],
    availability: 'Very High',
    searchTerms: ['beagle', 'beagle dog']
  },
  {
    id: 'dachshund',
    name: 'Dachshund',
    category: 'Hound',
    size: 'Small',
    weight: '16-32 lbs',
    height: '8-9 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'Medium',
    lifespan: '12-16 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Clever', 'Stubborn', 'Devoted', 'Lively'],
    commonIssues: ['Back problems', 'Obesity', 'Dental issues'],
    availability: 'Very High',
    searchTerms: ['dachshund', 'wiener dog', 'sausage dog']
  },
  {
    id: 'bloodhound',
    name: 'Bloodhound',
    category: 'Hound',
    size: 'Large',
    weight: '80-110 lbs',
    height: '23-27 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '10-12 years',
    climate: ['Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Independent', 'Friendly', 'Gentle', 'Even-tempered'],
    commonIssues: ['Hip dysplasia', 'Bloat', 'Eye problems'],
    availability: 'Medium',
    searchTerms: ['bloodhound', 'st hubert hound']
  },
  {
    id: 'basset-hound',
    name: 'Basset Hound',
    category: 'Hound',
    size: 'Medium',
    weight: '40-65 lbs',
    height: '14 inches',
    energyLevel: 'Low',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '10-12 years',
    climate: ['Moderate'],
    livingSpace: ['Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Charming', 'Patient', 'Low-key', 'Stubborn'],
    commonIssues: ['Ear infections', 'Obesity', 'Back problems'],
    availability: 'High',
    searchTerms: ['basset hound', 'basset']
  },
  {
    id: 'greyhound',
    name: 'Greyhound',
    category: 'Hound',
    size: 'Large',
    weight: '60-70 lbs',
    height: '27-30 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '10-13 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Gentle', 'Independent', 'Noble', 'Quiet'],
    commonIssues: ['Bloat', 'Dental problems', 'Sensitivity to anesthesia'],
    availability: 'Medium',
    searchTerms: ['greyhound', 'racing dog']
  },
  {
    id: 'whippet',
    name: 'Whippet',
    category: 'Hound',
    size: 'Medium',
    weight: '25-40 lbs',
    height: '18-22 inches',
    energyLevel: 'Medium-High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '12-15 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Affectionate', 'Playful', 'Calm', 'Gentle'],
    commonIssues: ['Heart disease', 'Deafness', 'Eye problems'],
    availability: 'Medium',
    searchTerms: ['whippet', 'snap dog']
  },
  {
    id: 'rhodesian-ridgeback',
    name: 'Rhodesian Ridgeback',
    category: 'Hound',
    size: 'Large',
    weight: '70-85 lbs',
    height: '24-27 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Warm', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Dignified', 'Independent', 'Intelligent', 'Strong-willed'],
    commonIssues: ['Hip dysplasia', 'Dermoid sinus', 'Thyroid problems'],
    availability: 'Medium',
    searchTerms: ['rhodesian ridgeback', 'african lion hound']
  },
  {
    id: 'borzoi',
    name: 'Borzoi',
    category: 'Hound',
    size: 'Large',
    weight: '60-105 lbs',
    height: '26-32 inches',
    energyLevel: 'Low-Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '9-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Quiet', 'Intelligent', 'Independent', 'Athletic'],
    commonIssues: ['Bloat', 'Progressive retinal atrophy', 'Osteochondritis dissecans'],
    availability: 'Low',
    searchTerms: ['borzoi', 'russian wolfhound']
  },
  {
    id: 'irish-wolfhound',
    name: 'Irish Wolfhound',
    category: 'Hound',
    size: 'Extra Large',
    weight: '105-120 lbs',
    height: '30-35 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '6-8 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Dignified', 'Gentle', 'Thoughtful', 'Patient'],
    commonIssues: ['Heart disease', 'Bone cancer', 'Bloat'],
    availability: 'Low',
    searchTerms: ['irish wolfhound', 'wolfhound']
  },
  
  // WORKING GROUP
  {
    id: 'siberian-husky',
    name: 'Siberian Husky',
    category: 'Working',
    size: 'Medium',
    weight: '35-60 lbs',
    height: '20-23.5 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Very High',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Mischievous', 'Outgoing', 'Alert', 'Independent'],
    commonIssues: ['Eye problems', 'Hip dysplasia', 'Skin conditions'],
    availability: 'High',
    searchTerms: ['siberian husky', 'husky dog']
  },
  {
    id: 'boxer',
    name: 'Boxer',
    category: 'Working',
    size: 'Large',
    weight: '50-70 lbs',
    height: '21.5-25 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Moderate'],
    livingSpace: ['Small House', 'Large House'],
    exerciseNeeds: 'High',
    personality: ['Playful', 'Energetic', 'Intelligent', 'Alert'],
    commonIssues: ['Cancer', 'Heart conditions', 'Hip dysplasia'],
    availability: 'High',
    searchTerms: ['boxer dog', 'boxer']
  },
  {
    id: 'doberman-pinscher',
    name: 'Doberman Pinscher',
    category: 'Working',
    size: 'Large',
    weight: '60-100 lbs',
    height: '24-28 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Alert', 'Fearless', 'Loyal', 'Intelligent'],
    commonIssues: ['Dilated cardiomyopathy', 'Von Willebrand disease', 'Hip dysplasia'],
    availability: 'Medium',
    searchTerms: ['doberman pinscher', 'doberman']
  },
  {
    id: 'great-dane',
    name: 'Great Dane',
    category: 'Working',
    size: 'Extra Large',
    weight: '100-175 lbs',
    height: '28-34 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '7-10 years',
    climate: ['Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Friendly', 'Patient', 'Dependable', 'Reserved'],
    commonIssues: ['Bloat', 'Heart disease', 'Hip dysplasia'],
    availability: 'Medium',
    searchTerms: ['great dane', 'danish hound']
  },
  {
    id: 'rottweiler',
    name: 'Rottweiler',
    category: 'Working',
    size: 'Large',
    weight: '80-135 lbs',
    height: '22-27 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '8-10 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Confident', 'Steady', 'Alert', 'Courageous'],
    commonIssues: ['Hip dysplasia', 'Heart conditions', 'Cancer'],
    availability: 'High',
    searchTerms: ['rottweiler', 'rottie']
  },
  {
    id: 'bernese-mountain-dog',
    name: 'Bernese Mountain Dog',
    category: 'Working',
    size: 'Large',
    weight: '70-115 lbs',
    height: '23-27.5 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '7-10 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Good-natured', 'Calm', 'Strong', 'Affectionate'],
    commonIssues: ['Cancer', 'Hip and elbow dysplasia', 'Bloat'],
    availability: 'Medium',
    searchTerms: ['bernese mountain dog', 'berner']
  },
  {
    id: 'newfoundland',
    name: 'Newfoundland',
    category: 'Working',
    size: 'Extra Large',
    weight: '100-150 lbs',
    height: '26-28 inches',
    energyLevel: 'Low',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Low',
    shedding: 'High',
    lifespan: '9-10 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Sweet', 'Patient', 'Devoted', 'Gentle'],
    commonIssues: ['Hip dysplasia', 'Heart problems', 'Cystinuria'],
    availability: 'Medium',
    searchTerms: ['newfoundland', 'newf', 'newfie']
  },
  {
    id: 'saint-bernard',
    name: 'Saint Bernard',
    category: 'Working',
    size: 'Extra Large',
    weight: '120-180 lbs',
    height: '26-30 inches',
    energyLevel: 'Low',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'High',
    lifespan: '8-10 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Low',
    personality: ['Gentle', 'Friendly', 'Patient', 'Watchful'],
    commonIssues: ['Hip dysplasia', 'Bloat', 'Heart conditions'],
    availability: 'Medium',
    searchTerms: ['saint bernard', 'st bernard']
  },
  {
    id: 'akita',
    name: 'Akita',
    category: 'Working',
    size: 'Large',
    weight: '70-130 lbs',
    height: '24-28 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Poor',
    barking: 'Low',
    shedding: 'High',
    lifespan: '10-13 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Loyal', 'Dignified', 'Courageous', 'Aloof'],
    commonIssues: ['Hip dysplasia', 'Autoimmune diseases', 'Progressive retinal atrophy'],
    availability: 'Medium',
    searchTerms: ['akita', 'akita inu', 'japanese akita']
  },

  // TERRIER GROUP
  {
    id: 'american-staffordshire-terrier',
    name: 'American Staffordshire Terrier',
    category: 'Terrier',
    size: 'Medium',
    weight: '40-70 lbs',
    height: '17-19 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '12-16 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Confident', 'Smart', 'Good-natured', 'Courageous'],
    commonIssues: ['Hip dysplasia', 'Skin allergies', 'Heart disease'],
    availability: 'High',
    searchTerms: ['american staffordshire terrier', 'amstaff']
  },
  {
    id: 'bull-terrier',
    name: 'Bull Terrier',
    category: 'Terrier',
    size: 'Medium',
    weight: '35-75 lbs',
    height: '21-22 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '12-13 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House'],
    exerciseNeeds: 'High',
    personality: ['Playful', 'Mischievous', 'Charming', 'Stubborn'],
    commonIssues: ['Deafness', 'Kidney disease', 'Heart problems'],
    availability: 'Medium',
    searchTerms: ['bull terrier', 'english bull terrier']
  },
  {
    id: 'west-highland-white-terrier',
    name: 'West Highland White Terrier',
    category: 'Terrier',
    size: 'Small',
    weight: '15-20 lbs',
    height: '10-11 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'Low',
    lifespan: '13-15 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Friendly', 'Alert', 'Active', 'Independent'],
    commonIssues: ['Skin allergies', 'Legg-Calve-Perthes disease', 'Addisons disease'],
    availability: 'High',
    searchTerms: ['west highland white terrier', 'westie']
  },
  {
    id: 'scottish-terrier',
    name: 'Scottish Terrier',
    category: 'Terrier',
    size: 'Small',
    weight: '18-22 lbs',
    height: '10 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '12-15 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Independent', 'Confident', 'Dignified', 'Stubborn'],
    commonIssues: ['Bladder cancer', 'Von Willebrand disease', 'Craniomandibular osteopathy'],
    availability: 'Medium',
    searchTerms: ['scottish terrier', 'scottie']
  },
  {
    id: 'yorkshire-terrier',
    name: 'Yorkshire Terrier',
    category: 'Terrier',
    size: 'Extra Small',
    weight: '7 lbs',
    height: '7-8 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'Low',
    lifespan: '13-16 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Affectionate', 'Sprightly', 'Tomboyish', 'Feisty'],
    commonIssues: ['Luxating patella', 'Dental issues', 'Tracheal collapse'],
    availability: 'Very High',
    searchTerms: ['yorkshire terrier', 'yorkie']
  },
  {
    id: 'airedale-terrier',
    name: 'Airedale Terrier',
    category: 'Terrier',
    size: 'Medium',
    weight: '50-70 lbs',
    height: '21-23 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '11-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Friendly', 'Clever', 'Courageous', 'Determined'],
    commonIssues: ['Hip dysplasia', 'Allergies', 'Heart disease'],
    availability: 'Medium',
    searchTerms: ['airedale terrier', 'king of terriers']
  },
  {
    id: 'cairn-terrier',
    name: 'Cairn Terrier',
    category: 'Terrier',
    size: 'Small',
    weight: '13-14 lbs',
    height: '9.5-10 inches',
    energyLevel: 'High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '13-15 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Alert', 'Cheerful', 'Busy', 'Independent'],
    commonIssues: ['Globoid cell leukodystrophy', 'Craniomandibular osteopathy', 'Allergies'],
    availability: 'Medium',
    searchTerms: ['cairn terrier', 'toto dog']
  },
  {
    id: 'border-terrier',
    name: 'Border Terrier',
    category: 'Terrier',
    size: 'Small',
    weight: '11-15 lbs',
    height: '10-11 inches',
    energyLevel: 'High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '12-15 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Affectionate', 'Alert', 'Active', 'Plucky'],
    commonIssues: ['Hip dysplasia', 'Heart defects', 'Juvenile cataracts'],
    availability: 'Medium',
    searchTerms: ['border terrier']
  },
  {
    id: 'jack-russell-terrier',
    name: 'Jack Russell Terrier',
    category: 'Terrier',
    size: 'Small',
    weight: '13-17 lbs',
    height: '10-15 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'Medium',
    lifespan: '13-16 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Energetic', 'Fearless', 'Athletic', 'Vocal'],
    commonIssues: ['Legg-Calve-Perthes disease', 'Deafness', 'Eye disorders'],
    availability: 'High',
    searchTerms: ['jack russell terrier', 'jack russell']
  },

  // TOY GROUP
  {
    id: 'chihuahua',
    name: 'Chihuahua',
    category: 'Toy',
    size: 'Extra Small',
    weight: '2-6 lbs',
    height: '5-8 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'Medium',
    lifespan: '14-16 years',
    climate: ['Warm'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Charming', 'Graceful', 'Sassy', 'Alert'],
    commonIssues: ['Dental issues', 'Patellar luxation', 'Heart problems'],
    availability: 'Very High',
    searchTerms: ['chihuahua', 'chi']
  },
  {
    id: 'pomeranian',
    name: 'Pomeranian',
    category: 'Toy',
    size: 'Extra Small',
    weight: '3-7 lbs',
    height: '6-7 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'High',
    shedding: 'High',
    lifespan: '12-16 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Inquisitive', 'Bold', 'Lively', 'Alert'],
    commonIssues: ['Tracheal collapse', 'Dental problems', 'Patellar luxation'],
    availability: 'High',
    searchTerms: ['pomeranian', 'pom']
  },
  {
    id: 'shih-tzu',
    name: 'Shih Tzu',
    category: 'Toy',
    size: 'Small',
    weight: '9-16 lbs',
    height: '9-10.5 inches',
    energyLevel: 'Low',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '10-18 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Affectionate', 'Playful', 'Outgoing', 'Alert'],
    commonIssues: ['Breathing problems', 'Eye issues', 'Hip dysplasia'],
    availability: 'High',
    searchTerms: ['shih tzu', 'chrysanthemum dog']
  },
  {
    id: 'cavalier-king-charles-spaniel',
    name: 'Cavalier King Charles Spaniel',
    category: 'Toy',
    size: 'Small',
    weight: '13-18 lbs',
    height: '12-13 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '9-14 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Affectionate', 'Gentle', 'Graceful', 'Adaptable'],
    commonIssues: ['Heart problems', 'Syringomyelia', 'Eye issues'],
    availability: 'High',
    searchTerms: ['cavalier king charles spaniel', 'cavalier']
  },
  {
    id: 'pug',
    name: 'Pug',
    category: 'Toy',
    size: 'Small',
    weight: '14-18 lbs',
    height: '10-13 inches',
    energyLevel: 'Low-Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'High',
    lifespan: '13-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Charming', 'Mischievous', 'Loving', 'Sociable'],
    commonIssues: ['Breathing problems', 'Eye issues', 'Obesity'],
    availability: 'High',
    searchTerms: ['pug']
  },
  {
    id: 'maltese',
    name: 'Maltese',
    category: 'Toy',
    size: 'Extra Small',
    weight: '4-7 lbs',
    height: '7-9 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Very Low',
    lifespan: '12-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Gentle', 'Playful', 'Charming', 'Fearless'],
    commonIssues: ['Dental problems', 'Patellar luxation', 'Shaker syndrome'],
    availability: 'High',
    searchTerms: ['maltese', 'maltese dog']
  },
  {
    id: 'papillon',
    name: 'Papillon',
    category: 'Toy',
    size: 'Extra Small',
    weight: '5-10 lbs',
    height: '8-11 inches',
    energyLevel: 'High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Fair',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '14-16 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Happy', 'Alert', 'Friendly', 'Intelligent'],
    commonIssues: ['Patellar luxation', 'Dental problems', 'Progressive retinal atrophy'],
    availability: 'Medium',
    searchTerms: ['papillon', 'continental toy spaniel']
  },
  {
    id: 'brussels-griffon',
    name: 'Brussels Griffon',
    category: 'Toy',
    size: 'Extra Small',
    weight: '8-10 lbs',
    height: '7-10 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '12-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Alert', 'Curious', 'Self-important', 'Sensitive'],
    commonIssues: ['Respiratory issues', 'Eye problems', 'Patellar luxation'],
    availability: 'Low',
    searchTerms: ['brussels griffon', 'griffon bruxellois']
  },
  
  // NON-SPORTING GROUP
  {
    id: 'bulldog',
    name: 'Bulldog',
    category: 'Non-Sporting',
    size: 'Medium',
    weight: '40-50 lbs',
    height: '14-15 inches',
    energyLevel: 'Low',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '8-10 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Docile', 'Willful', 'Friendly', 'Gregarious'],
    commonIssues: ['Breathing problems', 'Overheating', 'Skin infections'],
    availability: 'High',
    searchTerms: ['bulldog', 'english bulldog']
  },
  {
    id: 'french-bulldog',
    name: 'French Bulldog',
    category: 'Non-Sporting',
    size: 'Small',
    weight: '16-28 lbs',
    height: '11-13 inches',
    energyLevel: 'Low-Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'Medium',
    lifespan: '10-12 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Playful', 'Alert', 'Adaptable', 'Smart'],
    commonIssues: ['Breathing problems', 'Overheating', 'Spinal disorders'],
    availability: 'Very High',
    searchTerms: ['french bulldog', 'frenchie']
  },
  {
    id: 'poodle-standard',
    name: 'Standard Poodle',
    category: 'Non-Sporting',
    size: 'Large',
    weight: '40-70 lbs',
    height: '15+ inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Very Low',
    lifespan: '10-18 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House'],
    exerciseNeeds: 'High',
    personality: ['Intelligent', 'Active', 'Alert', 'Instinctual'],
    commonIssues: ['Hip dysplasia', 'Eye disorders', 'Epilepsy'],
    availability: 'High',
    searchTerms: ['standard poodle', 'poodle']
  },
  {
    id: 'boston-terrier',
    name: 'Boston Terrier',
    category: 'Non-Sporting',
    size: 'Small',
    weight: '12-25 lbs',
    height: '15-17 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '13-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Friendly', 'Bright', 'Amusing', 'Well-mannered'],
    commonIssues: ['Breathing problems', 'Eye issues', 'Allergies'],
    availability: 'High',
    searchTerms: ['boston terrier', 'boston bull']
  },
  {
    id: 'shiba-inu',
    name: 'Shiba Inu',
    category: 'Non-Sporting',
    size: 'Small',
    weight: '17-23 lbs',
    height: '13.5-16.5 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'High',
    lifespan: '13-16 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Alert', 'Attentive', 'Independent', 'Loyal'],
    commonIssues: ['Allergies', 'Glaucoma', 'Patellar luxation'],
    availability: 'Medium',
    searchTerms: ['shiba inu', 'shiba']
  },
  {
    id: 'chow-chow',
    name: 'Chow Chow',
    category: 'Non-Sporting',
    size: 'Medium',
    weight: '45-70 lbs',
    height: '17-20 inches',
    energyLevel: 'Low',
    groomingNeeds: 'High',
    trainingDifficulty: 'Hard',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Low',
    shedding: 'High',
    lifespan: '8-12 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Dignified', 'Serious', 'Aloof', 'Independent'],
    commonIssues: ['Hip dysplasia', 'Entropion', 'Elbow dysplasia'],
    availability: 'Medium',
    searchTerms: ['chow chow', 'chow']
  },
  {
    id: 'bichon-frise',
    name: 'Bichon Frise',
    category: 'Non-Sporting',
    size: 'Small',
    weight: '12-18 lbs',
    height: '9.5-11.5 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Very Low',
    lifespan: '14-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Playful', 'Curious', 'Peppy', 'Affectionate'],
    commonIssues: ['Allergies', 'Bladder stones', 'Patellar luxation'],
    availability: 'High',
    searchTerms: ['bichon frise', 'bichon']
  },
  {
    id: 'dalmatian',
    name: 'Dalmatian',
    category: 'Non-Sporting',
    size: 'Large',
    weight: '45-70 lbs',
    height: '19-24 inches',
    energyLevel: 'High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '11-13 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Dignified', 'Intelligent', 'Active', 'Outgoing'],
    commonIssues: ['Deafness', 'Urinary stones', 'Allergies'],
    availability: 'Medium',
    searchTerms: ['dalmatian', 'dal', 'coach dog']
  },

  // HERDING GROUP
  {
    id: 'german-shepherd',
    name: 'German Shepherd',
    category: 'Herding',
    size: 'Large',
    weight: '50-90 lbs',
    height: '22-26 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '7-10 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Confident', 'Courageous', 'Smart', 'Loyal'],
    commonIssues: ['Hip dysplasia', 'Degenerative myelopathy', 'Bloat'],
    availability: 'Very High',
    searchTerms: ['german shepherd', 'gsd', 'alsatian']
  },
  {
    id: 'australian-shepherd',
    name: 'Australian Shepherd',
    category: 'Herding',
    size: 'Medium',
    weight: '40-65 lbs',
    height: '18-23 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-15 years',
    climate: ['Cold', 'Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Smart', 'Work-oriented', 'Exuberant', 'Versatile'],
    commonIssues: ['Hip dysplasia', 'Eye problems', 'Epilepsy'],
    availability: 'High',
    searchTerms: ['australian shepherd', 'aussie']
  },
  {
    id: 'border-collie',
    name: 'Border Collie',
    category: 'Herding',
    size: 'Medium',
    weight: '30-55 lbs',
    height: '18-22 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-15 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Affectionate', 'Smart', 'Energetic', 'Alert'],
    commonIssues: ['Hip dysplasia', 'Collie eye anomaly', 'Epilepsy'],
    availability: 'High',
    searchTerms: ['border collie', 'sheepdog']
  },
  {
    id: 'shetland-sheepdog',
    name: 'Shetland Sheepdog',
    category: 'Herding',
    size: 'Small',
    weight: '15-25 lbs',
    height: '13-16 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'High',
    shedding: 'High',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Playful', 'Energetic', 'Bright', 'Sensitive'],
    commonIssues: ['Collie eye anomaly', 'Hip dysplasia', 'Thyroid issues'],
    availability: 'Medium',
    searchTerms: ['shetland sheepdog', 'sheltie']
  },
  {
    id: 'australian-cattle-dog',
    name: 'Australian Cattle Dog',
    category: 'Herding',
    size: 'Medium',
    weight: '35-50 lbs',
    height: '17-20 inches',
    energyLevel: 'Very High',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Fair',
    goodWithPets: 'Fair',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-16 years',
    climate: ['Moderate', 'Warm'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Very High',
    personality: ['Alert', 'Curious', 'Loyal', 'Protective'],
    commonIssues: ['Hip dysplasia', 'Progressive retinal atrophy', 'Deafness'],
    availability: 'Medium',
    searchTerms: ['australian cattle dog', 'blue heeler', 'red heeler']
  },
  {
    id: 'pembroke-welsh-corgi',
    name: 'Pembroke Welsh Corgi',
    category: 'Herding',
    size: 'Small',
    weight: '25-30 lbs',
    height: '10-12 inches',
    energyLevel: 'Medium-High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-13 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Affectionate', 'Smart', 'Alert', 'Even-tempered'],
    commonIssues: ['Hip dysplasia', 'Progressive retinal atrophy', 'Degenerative myelopathy'],
    availability: 'High',
    searchTerms: ['pembroke welsh corgi', 'corgi']
  },
  {
    id: 'cardigan-welsh-corgi',
    name: 'Cardigan Welsh Corgi',
    category: 'Herding',
    size: 'Small',
    weight: '25-38 lbs',
    height: '10.5-12.5 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-15 years',
    climate: ['Moderate'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Affectionate', 'Loyal', 'Smart', 'Adaptable'],
    commonIssues: ['Progressive retinal atrophy', 'Intervertebral disc disease', 'Hip dysplasia'],
    availability: 'Medium',
    searchTerms: ['cardigan welsh corgi', 'cardigan corgi']
  },
  {
    id: 'collie',
    name: 'Collie',
    category: 'Herding',
    size: 'Large',
    weight: '50-75 lbs',
    height: '22-26 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'High',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate'],
    livingSpace: ['Large House', 'Farm'],
    exerciseNeeds: 'Medium',
    personality: ['Devoted', 'Graceful', 'Proud', 'Responsive'],
    commonIssues: ['Collie eye anomaly', 'Hip dysplasia', 'Dermatomyositis'],
    availability: 'Medium',
    searchTerms: ['collie', 'rough collie', 'smooth collie']
  },

  // MIXED BREEDS
  {
    id: 'goldendoodle',
    name: 'Goldendoodle',
    category: 'Mixed',
    size: 'Medium',
    weight: '45-75 lbs',
    height: '20-24 inches',
    energyLevel: 'High',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '10-15 years',
    climate: ['Cold', 'Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Friendly', 'Intelligent', 'Gentle', 'Affectionate'],
    commonIssues: ['Hip dysplasia', 'Ear infections', 'Allergies'],
    availability: 'High',
    searchTerms: ['goldendoodle', 'golden doodle']
  },
  {
    id: 'labradoodle',
    name: 'Labradoodle',
    category: 'Mixed',
    size: 'Medium',
    weight: '45-65 lbs',
    height: '21-24 inches',
    energyLevel: 'High',
    groomingNeeds: 'Medium',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Excellent',
    barking: 'Low',
    shedding: 'Low',
    lifespan: '12-14 years',
    climate: ['Cold', 'Moderate', 'Warm'],
    livingSpace: ['Small House', 'Large House', 'Farm'],
    exerciseNeeds: 'High',
    personality: ['Affectionate', 'Sociable', 'Energetic', 'Intelligent'],
    commonIssues: ['Hip dysplasia', 'Ear infections', 'Progressive retinal atrophy'],
    availability: 'High',
    searchTerms: ['labradoodle', 'labrador poodle']
  },
  {
    id: 'cockapoo',
    name: 'Cockapoo',
    category: 'Mixed',
    size: 'Small',
    weight: '12-24 lbs',
    height: '10-15 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Easy',
    goodWithKids: 'Excellent',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Low',
    lifespan: '12-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Friendly', 'Intelligent', 'Gentle', 'Playful'],
    commonIssues: ['Ear infections', 'Patellar luxation', 'Eye problems'],
    availability: 'High',
    searchTerms: ['cockapoo', 'cocker spaniel poodle']
  },
  {
    id: 'maltipoo',
    name: 'Maltipoo',
    category: 'Mixed',
    size: 'Extra Small',
    weight: '5-15 lbs',
    height: '8-14 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'High',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Very Low',
    lifespan: '10-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Low',
    personality: ['Gentle', 'Playful', 'Affectionate', 'Social'],
    commonIssues: ['Dental issues', 'Patellar luxation', 'White shaker syndrome'],
    availability: 'High',
    searchTerms: ['maltipoo', 'maltese poodle']
  },
  {
    id: 'puggle',
    name: 'Puggle',
    category: 'Mixed',
    size: 'Small',
    weight: '18-30 lbs',
    height: '10-15 inches',
    energyLevel: 'Medium',
    groomingNeeds: 'Low',
    trainingDifficulty: 'Medium',
    goodWithKids: 'Good',
    goodWithPets: 'Good',
    barking: 'Medium',
    shedding: 'Medium',
    lifespan: '10-15 years',
    climate: ['Moderate'],
    livingSpace: ['Apartment', 'Small House', 'Large House'],
    exerciseNeeds: 'Medium',
    personality: ['Loving', 'Social', 'Curious', 'Playful'],
    commonIssues: ['Breathing issues', 'Obesity', 'Skin allergies'],
    availability: 'Medium',
    searchTerms: ['puggle', 'pug beagle']
  }
];

// Geographic availability mapping
export const geographicAvailability = {
  'North America': {
    'Very High': ['labrador-retriever', 'golden-retriever', 'german-shepherd', 'beagle', 'poodle-standard', 'chihuahua', 'yorkshire-terrier', 'dachshund', 'boxer', 'french-bulldog', 'bulldog', 'rottweiler', 'shih-tzu', 'pomeranian', 'boston-terrier', 'pug', 'goldendoodle', 'labradoodle', 'cockapoo', 'maltipoo'],
    'High': ['german-shorthaired-pointer', 'siberian-husky', 'australian-shepherd', 'border-collie', 'cavalier-king-charles-spaniel', 'great-dane', 'doberman-pinscher', 'miniature-schnauzer', 'cocker-spaniel', 'pembroke-welsh-corgi', 'maltese', 'west-highland-white-terrier', 'bichon-frise', 'havanese', 'american-staffordshire-terrier', 'english-springer-spaniel', 'puggle'],
    'Medium': ['vizsla', 'weimaraner', 'brittany', 'bloodhound', 'rhodesian-ridgeback', 'pointer', 'english-setter', 'basset-hound', 'bull-terrier', 'shiba-inu', 'chow-chow', 'bernese-mountain-dog', 'akita', 'dalmatian', 'newfoundland', 'saint-bernard', 'shetland-sheepdog', 'australian-cattle-dog', 'collie', 'scottish-terrier', 'airedale-terrier', 'cairn-terrier', 'border-terrier', 'papillon', 'cardigan-welsh-corgi'],
    'Low': ['borzoi', 'irish-wolfhound', 'brussels-griffon', 'komondor', 'kuvasz', 'norwegian-elkhound', 'otterhound', 'saluki', 'belgian-sheepdog', 'bergamasco', 'chinook', 'dandie-dinmont-terrier', 'glen-of-imaal-terrier', 'norwegian-lundehund', 'swedish-vallhund']
  },
  'Europe': {
    'Very High': ['german-shepherd', 'labrador-retriever', 'golden-retriever', 'french-bulldog', 'bulldog', 'poodle-standard', 'dachshund', 'boxer', 'rottweiler', 'yorkshire-terrier'],
    'High': ['border-collie', 'cocker-spaniel', 'west-highland-white-terrier', 'cavalier-king-charles-spaniel', 'german-shorthaired-pointer', 'beagle', 'miniature-schnauzer', 'english-springer-spaniel', 'pug', 'shih-tzu'],
    'Medium': ['doberman-pinscher', 'basset-hound', 'great-dane', 'bernese-mountain-dog', 'maltese', 'dalmatian', 'shetland-sheepdog', 'bichon-frise', 'chihuahua', 'pomeranian', 'collie', 'bull-terrier', 'scottish-terrier', 'papillon', 'boston-terrier', 'havanese', 'shiba-inu'],
    'Low': ['akita', 'siberian-husky', 'rhodesian-ridgeback', 'australian-shepherd', 'australian-cattle-dog', 'vizsla', 'weimaraner', 'brittany', 'pointer', 'english-setter', 'airedale-terrier', 'cairn-terrier', 'border-terrier']
  },
  'Asia': {
    'Very High': ['shiba-inu', 'akita', 'poodle-standard', 'golden-retriever', 'labrador-retriever', 'chihuahua', 'pomeranian', 'maltese', 'shih-tzu'],
    'High': ['french-bulldog', 'pug', 'dachshund', 'german-shepherd', 'chow-chow', 'papillon', 'siberian-husky', 'yorkshire-terrier', 'beagle'],
    'Medium': ['border-collie', 'cavalier-king-charles-spaniel', 'bichon-frise', 'boxer', 'great-dane', 'bulldog', 'doberman-pinscher', 'rottweiler', 'miniature-schnauzer', 'cocker-spaniel'],
    'Low': ['australian-shepherd', 'vizsla', 'bernese-mountain-dog', 'dalmatian', 'collie', 'west-highland-white-terrier', 'scottish-terrier', 'havanese', 'boston-terrier', 'english-springer-spaniel', 'bull-terrier', 'pembroke-welsh-corgi']
  },
  'Other': {
    'Very High': ['labrador-retriever', 'golden-retriever', 'german-shepherd', 'poodle-standard', 'rottweiler', 'boxer'],
    'High': ['beagle', 'border-collie', 'cocker-spaniel', 'bulldog', 'dachshund', 'doberman-pinscher', 'great-dane'],
    'Medium': ['dalmatian', 'chihuahua', 'maltese', 'shih-tzu', 'yorkshire-terrier', 'west-highland-white-terrier', 'cavalier-king-charles-spaniel', 'australian-shepherd', 'siberian-husky', 'miniature-schnauzer', 'pomeranian', 'pug', 'french-bulldog'],
    'Low': ['akita', 'shiba-inu', 'chow-chow', 'bernese-mountain-dog', 'newfoundland', 'saint-bernard', 'borzoi', 'irish-wolfhound', 'brussels-griffon', 'vizsla', 'weimaraner', 'brittany', 'pointer', 'english-setter', 'bloodhound', 'rhodesian-ridgeback', 'basset-hound', 'bull-terrier', 'papillon', 'bichon-frise', 'shetland-sheepdog', 'australian-cattle-dog', 'collie', 'scottish-terrier', 'airedale-terrier', 'cairn-terrier', 'border-terrier', 'pembroke-welsh-corgi', 'cardigan-welsh-corgi']
  }
};